<template>
	<el-row>
		<el-button @click="add">添加品类知识库+</el-button>
		<el-row>
			<el-col>
				<span>分类名称</span>
				<el-cascader v-model="arr" :options="options2" :props="props" style="margin: 0 10px; width: 300px">
				</el-cascader>
				<span>商品款式</span>
				<el-input v-model="commodityStyle" style="margin: 0 10px; width: 300px">
				</el-input>
				<el-button @click="screen()" type="primary">筛选</el-button>
				<el-button @click="Export()">导出Excel</el-button>
				<el-button @click="reset()" type="success">重置</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData">
					<el-table-column label="序号" width="50px" prop="id"></el-table-column>
					<el-table-column label="一级分类" prop="primaryName"></el-table-column>
					<el-table-column label="二级分类" prop="secondaryName"></el-table-column>
					<el-table-column label="销售人群" prop="arr"></el-table-column>
					<el-table-column label="商品款式" prop="commodityStyle"></el-table-column>
					<el-table-column label="品类科普">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'01')">品类科普</el-button>
						</template>
					</el-table-column>
					<el-table-column label="独家知识">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'02')">独家知识</el-button>
						</template>
					</el-table-column>
					<el-table-column label="权威背书">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'04')">权威背书</el-button>
						</template>
					</el-table-column>
					<el-table-column label="售后知识">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'03')">售后知识</el-button>
						</template>
					</el-table-column>

					<el-table-column label="相关公众号">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'05')">相关公众号</el-button>
						</template>
					</el-table-column>
					<el-table-column label="品类推广文案">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'06')">品类推广文案</el-button>
						</template>
					</el-table-column>
					<el-table-column label="社群讲解">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'16')">社群讲解</el-button>
						</template>
					</el-table-column>
					<el-table-column label="更新时间" prop="updateTime"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="toKuanShi(scope.row)" type="text" size="mini">款式商品</el-button>
							<el-button @click="editorCircle(scope.row)" type="text">编辑</el-button>
							<el-button @click="viewCircle(scope.row)" type="text">查看</el-button>
							<el-button @click="delCircle(scope.row)" type="text">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto; width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30, 60, 100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :visible.sync="dialogVisible" :title="title" center width="40%">
			<el-form ref="info" :model="info" label-position="right" label-width="80px">
				<el-form-item label="分类" prop="arr" :rules="[{ 
					required: true, message: '请选择分类', trigger: 'change' }]">
					<el-cascader v-model="info.arr" :options="options2" :props="props" style="width: 100%;">
					</el-cascader>
				</el-form-item>
				<el-form-item label="商品款式" prop="commodityStyle" :rules="[{ 
					required: true, message: '请输入商品款式', trigger: 'change' }]">
					<el-input v-model="info.commodityStyle"></el-input>
				</el-form-item>
				<el-form-item label="销售人群" prop="labelIds" :rules="[{
					required: true, message: '请选择销售人群', trigger: 'change'
				}]">
					<el-cascader style="width: 100%;" v-model="info.labelIds" :options="options3" :props="props2"
						clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item>
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit">确认</el-button>
				</el-form-item>

			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				options2: [], //分类数组
				options3: {}, //销售人群
				commodityStyle: '',
				props: {
					value: "id",
					label: "name",
					children: "sonList",
				},
				props2: {
					value: "id",
					label: "name",
					children: "sonList2",
					multiple: true
				},
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 30,
				arr: [],
				dialogVisible: false,
				title: "",
				arr: [],
				id: '',
				info: {
					id: '',
					arr: [],
					primaryType: "",
					secondary: "",
					commodityStyle: "",
					labelIds: []
				},
			}
		},
		methods: {
			toKuanShi(row) {
				console.log(row);
				this.$router.push({
					path: '/catStyle',
					query: {
						primaryType: row.primaryType,
						secondary: row.secondary
					}
				})
			},
			toView(id, num) {
				this.$router.push({
					path: '/catDetails',
					query: {
						id: id,
						kinds: num
					}
				})
			},
			add() {
				this.dialogVisible = true;
				this.title = "添加品类知识库";
				this.info = {
					arr: [],
					primaryType: "",
					secondary: "",
					commodityStyle: "",
					labelIds: []
				};
			},
			screen() {
				this.getList()
			},
			Export() {
				let primaryType = null
				let secondary = null
				if (this.arr.length > 0) {
					primaryType = arr[0]
					secondary = arr[1]
				}
				this.$http.post('/api/statistics/knowledgeBase/exportKnowledgeBase', {
					"id": null, //ID
					"primaryType": primaryType, //一级品类编号
					"secondary": secondary, //二级品类编号
					"salesCrowd": "", //销售人群
					"commodityStyle": "" //商品款式
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出品类知识库表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '品类知识库列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			reset() {
				this.arr = []
				this.commodityStyle = ''
				this.getList()
			},
			//编辑
			editorCircle(row) {
				console.log(row)
				this.title = '编辑品类知识库'
				this.dialogVisible = true
				let arr2 = []
				if (row.labelVos.length > 0) {
					row.labelVos.forEach(i => {
						arr2.push([i.parentLabelId, i.labelId])
					})
				}
				this.info = {
					id: row.id,
					arr: [row.primaryType, row.secondary],
					primaryType: row.primaryType,
					secondary: row.secondary,
					commodityStyle: row.commodityStyle,
					labelIds: arr2
				}
				console.log(this.info);
			},
			submit() {
				console.log(this.info.labelIds);
				this.$refs.info.validate((vai) => {
					if (vai) {
						if (this.info.arr.length > 0) {
							this.info.primaryType = this.info.arr[0]
							this.info.secondary = this.info.arr[1]
						}
						let labelIds = []
						if (this.info.labelIds.length > 0) {
							this.info.labelIds.forEach(i => {
								labelIds.push(i[1])
							})
						}
						if (this.title == '添加品类知识库') {
							this.$http.post('/api/plant/knowledgeBase/insertKnowledgeBase', {
								"primaryType": this.info.primaryType,
								"secondary": this.info.secondary,
								"commodityStyle": this.info.commodityStyle,
								"labelIds": labelIds
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success('添加成功')
									this.getList()
									this.dialogVisible = false
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else {
							this.$http.post('/api/plant/knowledgeBase/updateKnowledgeBase', {
								"id": this.info.id,
								"primaryType": this.info.primaryType,
								"secondary": this.info.secondary,
								"commodityStyle": this.info.commodityStyle,
								"labelIds": labelIds
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success('更新成功')
									this.getList()
									this.dialogVisible = false
								} else {
									this.$message.error(res.data.msg)
								}
							})
						}
					}
				});
			},
			delCircle(row) {
				console.log(row);
				this.$confirm('此操作将永久删除该品类, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/knowledgeBase/updateKnowledgeBase', {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success('删除成功')
							this.getList()
						} else {
							this.$message({
								type: 'info',
								message: '删除失败'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			viewCircle(row) {
				console.log(row);
				this.id = row.id
				this.$router.push({
					path: "./catDetails",
					query: {
						id: row.id
					},
				});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size;
				//重新请求数据
				this.getList();
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage;
				//重新请求数据
				this.getList();
			},
			//获取列表
			getList() {
				let primaryType = null
				let secondary = null
				if (this.arr.length > 0) {
					primaryType = this.arr[0]
					secondary = this.arr[1]
				}
				this.$http.post("/api/plant/knowledgeBase/selectKnowledgeBase", {
						primaryType: primaryType, //二级品类编号
						secondary: secondary, //二级品类编号
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						commodityStyle: this.commodityStyle
					})
					.then((res) => {
						// console.log(res.data.data.list);
						if (res.data.data.list.length > 0) {
							res.data.data.list.forEach(i => {
								let labelVos2 = []
								let arr2 = []
								i.arr2 = []
								i.labelVos.forEach(i2 => {
									labelVos2.push(i2.labelName)
									i.arr = labelVos2.join(',')
									arr2.push(i2.parentId, i2.labelId)
									i.arr2.push(arr2)
								})
							})
							// console.log(res.data.data.list);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						} else {
							this.tableData = []
						}
					});
			},
			//获取分类
			getpaiCategory() {
				// this.$http.get(
				// 	"/api/product/productCategory/paiCategory?pageSize=999&pageNum=1&paiStatus=1", {}
				// ).then((res) => {
				// 	console.log(res.data.data.list);
				// 	this.options2 = res.data.data.list;
				// });
				this.$http.get('/api/plant/plantManage/productPaiCategoryDrop', {}).then(res => {
					console.log(res.data.data);
					this.options2 = res.data.data;
				})
			},
			//获取销售人群
			getinfo() {
				let arr = []
				this.$http.get("/api/plant/clrLabel/selectLabelList", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					// console.log(res.data.data);
					res.data.data.forEach((item) => {
						item.sonList.forEach(i => {
							arr.push({
								id: i.memberLabelId,
								name: i.name,
								sonList: i.sonList
							})
						})
					});
					arr.forEach(item => {
						item.sonList2 = []
						item.sonList.forEach(item2 => {
							item.sonList2.push({
								id: item2.memberLabelId,
								name: item2.name
							})
						})
					})
					console.log(arr);
					this.options3 = arr
				});
			},
		},
		created() {
			this.getList();
			this.getpaiCategory();
			this.getinfo();
		},
	};
</script>

<style scoped>
</style>
